import { createSelector } from 'reselect'
import API from '../../utils/http/api'

// Action Types
const REQUEST = 'steppingblocks/taskTypes/REQUEST'
const FAILURE = 'steppingblocks/taskTypes/FAILURE'
const SUCCESS = 'steppingblocks/taskTypes/SUCCESS'

// Reducer
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  results: [],
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return _state
  }
}

// Actions
export const performRetrieveTaskTypes = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/tasks/types')
    dispatch({
      type: SUCCESS,
      payload: {
        results,
      },
    })
    return results
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
  }
}

// Selectors
const taskTypes = state => state.taskTypes

export const getTaskTypes = createSelector(taskTypes, _ => _.results)

export const getTaskTypesByType = createSelector(getTaskTypes, _ =>
  _.reduce((acc, item) => {
    acc[item.type] = item.name
    return acc
  }, {}),
)

export const getFullTaskTypesByType = createSelector(getTaskTypes, _ =>
  _.reduce((acc, item) => {
    acc[item.type] = item
    return acc
  }, {}),
)

export const getTasksTypesGroupedByTask = createSelector(taskTypes, _ =>
  _.results.reduce((acc, item) => {
    acc[item.type] = item
    return acc
  }, {}),
)



// WEBPACK FOOTER //
// ./src/store/shared/taskTypesDuck.js